import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'software-deployment-frequency-report-deployment-details-dialog.header.title',
		defaultMessage: 'Deployment navigator',
		description: 'Heading for a modal dialog that shows details about a code deployment',
	},
	helpTooltip: {
		id: 'software-deployment-frequency-report-deployment-details-dialog.header.help-tooltip',
		defaultMessage:
			'Drill-down to your deployment to understand what issues were included with it.',
		description: 'Help text that explains the purpose of the deployment details dialog.',
	},
	closeButtonLabel: {
		id: 'software-deployment-frequency-report-deployment-details-dialog.header.close-button-label',
		defaultMessage: 'Close',
		description: 'Label for a button that closes a dialog.',
	},
});
